import { useEffect, useState } from "react";
import { Moon, Sun } from "lucide-react";

export function useTheme() {
  const [theme, setTheme] = useState(() => localStorage.getItem("dm_theme") || "dark");
  useEffect(() => {
    document.documentElement.classList.toggle("dark", theme === "dark");
    localStorage.setItem("dm_theme", theme);
  }, [theme]);
  return { theme, setTheme };
}

export const ThemeToggle = () => {
  const { theme, setTheme } = useTheme();
  return (
    <button
      data-testid="theme-toggle"
      aria-label="Toggle theme"
      onClick={() => setTheme(theme === "dark" ? "light" : "dark")}
      className="h-9 w-9 grid place-items-center border border-border hover:border-primary hover:text-primary transition-colors duration-150"
    >
      {theme === "dark" ? <Sun className="h-4 w-4" /> : <Moon className="h-4 w-4" />}
    </button>
  );
};
